// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_2bkUg-Ve9aEl3dL6jKOtSv","externalId":"_2PNA5GGVNz6D0ZJ23wF-c8"};